/**
 * @internal Not for public usage
 */
const __CACHE = new Map();
class CacheManager {
    constructor({ cacheTime = 300000, staleTime = 60000, }) {
        this.cacheTime = cacheTime;
        this.staleTime = staleTime;
        this.get = this.get.bind(this);
        this.set = this.set.bind(this);
        this.isFresh = this.isFresh.bind(this);
        this.isExists = this.isExists.bind(this);
        this.isStale = this.isStale.bind(this);
    }
    get(key) {
        return __CACHE.get(key);
    }
    set(key, payload) {
        __CACHE.set(key, { data: payload, timestamp: Date.now() });
    }
    isExists(key) {
        return __CACHE.has(key);
    }
    isFresh(key) {
        var _a;
        const cached = this.get(key);
        if (!cached)
            return false;
        const cacheTime = (_a = this.cacheTime) !== null && _a !== void 0 ? _a : 300000;
        const now = Date.now();
        const difference = now - cached.timestamp;
        return difference <= cacheTime;
    }
    isStale(key) {
        var _a, _b;
        const cached = this.get(key);
        if (!cached)
            return true;
        const cacheTime = (_a = this.cacheTime) !== null && _a !== void 0 ? _a : 300000;
        const staleTime = (_b = this.staleTime) !== null && _b !== void 0 ? _b : 60000;
        const now = Date.now();
        const difference = now - cached.timestamp;
        return difference > cacheTime && difference <= cacheTime + staleTime;
    }
}

export { CacheManager, __CACHE };
//# sourceMappingURL=CacheManager.js.map
